import styles from "./styles.module.css";

const GuideContent = () => (
  <div className={styles.content}>
    <h2>Üye Olma</h2>
    <p>
      Emlakjet.com’a bireysel üyelerimiz ücretsiz bir şekilde üye olabilmektedir. Bireysel üyelerimiz onaylanan üyelik
      işlemlerinin ardından bir adet ücretsiz ilan verebilmektedir.
    </p>
    <p>
      Kurumsal üyelik isteyen müşterilerimiz Emlakjet.com’un belirlediği ücret karşılığında kurumsal üye
      olabilmektedirler.
    </p>
    <h2>Üyelik Sözleşmesi</h2>
    <p>
      Üyelik sözleşmemiz sitemizden yazdırılabilir ve elektronik ortamda saklanmak üzere indirilebilir. Üyelerimiz
      herhangi bir zamanda sözleşmemize sitemiz üzerinden erişebilmektedir.
    </p>
    <p> Kurumsal üyelerimizin faturaları, kendilerine üyelik sonrasında gönderilmektedir.</p>
    <h2>Üyelik Aktifleme</h2>
    <p>
      Yeni üyelik yapmak isteyen müşterilerimize mail yoluyla aktifleme onayı gönderilmektedir ve onay sonrasında
      üyelikleri başlatılmaktadır.
    </p>
    <h2>Kişisel Verilerin Gizliliği</h2>
    <p>
      Emlakjet.com’a üye olurken ve sonrasındaki güncelleme işlemlerinizin ardından oluşan tüm bilgileriniz sizin
      onayınız olmadan üçüncü şahıslarla paylaşılmamaktadır. Üyelik sırasında bu paylaşımın aktiflenip/aktiflenmeyeceği
      seçilebileceği gibi, daha sonra da bu listelerden çıkmak mümkündür. Gizlilik politikamızla ilgili detaylı
      bilgilere; www.emlakjet.com/#gizlilik-politikasi bağlantısından ulaşabilirsiniz.
    </p>
    <h2>Uyuşmazlık Durumu</h2>
    <p>
      Emlakjet ve Üye arasında sağlanan Üyelik Sözleşmesi Türk hukukuna tabidir. Taraflar arasında işbu sözleşmeden
      kaynaklanacak uyuşmazlıklarda İstanbul Anadolu mahkemeleri ve icra daireleri münhasır yetkilidir. Bu
      uyuşmazlıklarda, EmlakJET’in defter ve kayıtları tek ve kesin delil olacaktır. Üyelik Sözleşmesi kabul edildiğinde
      Taraflar, elektronik ortamda ve Web Sitesi üzerinde gerçekleşen işlemlere ait, EmlakJET tarafından alınmış,
      bilgisayar çıktılarının da kesin delil niteliği taşıyacağı konusunda mutabık kalmış sayılırlar.
    </p>
  </div>
);

export default GuideContent;
